import { executeExportYtLoop } from '../exportyt-loop';

export async function executeExportYtFanOut(seedPrompt: string): Promise<string> {
    return await executeExportYtLoop(seedPrompt);
}
